<template>
  <div>
    <div class="box-content">
      <p class="Fuell-Text">{{ $t('company_export_settings_information') }}</p>
    </div>
    <div class="Fuell-Section">
      <div class="Fuell-Toolbar small">
        <h3 class="Fuell-Section--title">
          {{ $t('company_export_settings_file_formats') }}
        </h3>
        <button
          class="Fuell-ToolbarButton ml-auto blue"
          @click="showCreateFileFormats"
        >
          <span class="Fuell-ToolbarButton--label">
            {{ $t('company_export_settings_new_format') }}
          </span>
        </button>
      </div>
      <div>
        <file-formats-table @editFileFormat="showEditFileFormats">
        </file-formats-table>
      </div>
    </div>
    <div class="Fuell-Section">
      <div class="Fuell-Toolbar small">
        <h3 class="Fuell-Section--title">
          {{ $t('company_export_settings_field_mapping') }}
        </h3>

        <button
          class="Fuell-ToolbarButton ml-auto blue"
          @click="showCreateFieldsMapping"
        >
          <span class="Fuell-ToolbarButton--label">
            {{ $t('company_export_settings_new_mapping') }}
          </span>
        </button>
      </div>
      <div>
        <field-mapping-table @editFieldMapping="showEditFieldsMapping">
        </field-mapping-table>
      </div>
    </div>
    <create-file-format-modal
      :fileFormatId="fileFormatToEditId"
      :open.sync="showCreateFileFormatsModalFlag"
      v-if="showCreateFileFormatsModalFlag"
    ></create-file-format-modal>
    <create-field-mapping-modal
      :fieldMappingId="fieldMappingToEditId"
      :open.sync="showCreateFieldsMappingModalFlag"
      v-if="showCreateFieldsMappingModalFlag"
    ></create-field-mapping-modal>
  </div>
</template>

<script>
import FileFormatsTable from '../../_components/export_settings/FileFormatsTable'
import CreateFileFormatModal from '../../_components/export_settings/CreateFileFormatModal'
import FieldMappingTable from '../../_components/export_settings/FieldMappingTable'
import CreateFieldMappingModal from '../../_components/export_settings/CreateFieldMappingModal'

export default {
  name: 'ExportSettingsIndex',
  components: {
    FileFormatsTable,
    CreateFileFormatModal,
    FieldMappingTable,
    CreateFieldMappingModal
  },
  data () {
    return {
      showCreateFileFormatsModalFlag: false,
      fileFormatToEditId: 0,
      showCreateFieldsMappingModalFlag: false,
      fieldMappingToEditId: 0
    }
  },
  methods: {
    showCreateFileFormats () {
      this.fileFormatToEditId = null
      this.showCreateFileFormatsModalFlag = true
      this.showCreateFieldsMappingModalFlag = false
    },
    showEditFileFormats (event) {
      this.fileFormatToEditId = event
      this.showCreateFileFormatsModalFlag = true
      this.showCreateFieldsMappingModalFlag = false
    },
    showCreateFieldsMapping () {
      this.fieldMappingToEditId = null
      this.showCreateFileFormatsModalFlag = false
      this.showCreateFieldsMappingModalFlag = true
    },
    showEditFieldsMapping (event) {
      this.fieldMappingToEditId = event
      this.showCreateFieldsMappingModalFlag = true
      this.showCreateFileFormatsModalFlag = false
    }

  }

}
</script>

<style lang="scss" scoped>
</style>
